




































import { Vue, Component } from 'vue-property-decorator';
import logo from '@/assets/images/q-logo.png';
import OrganizeLogin from '@/views/login/Organize.vue';
import MemberLogin from '@/views/login/Member.vue';
import SmsLogin from '@/views/login/Sms.vue';

@Component({
  components: { OrganizeLogin, MemberLogin, SmsLogin },
})
export default class Login extends Vue {
  public logo = logo;
  public tabIndex = 0;
  public thisYear = new Date().getFullYear();
  public loginMode = { type: 'loginName', text: '使用验证码登录' };

  // 是否显示表单
  public isVisible(type: string) {
    return this.loginMode.type === type;
  }

  // 切换登录模式
  public onChangeLoginMode() {
    if (this.loginMode.type === 'loginName') {
      this.loginMode = { type: 'sms', text: '使用用户名登录' };
    } else {
      this.loginMode = { type: 'loginName', text: '使用验证码登录' };
    }
  }
}
